"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Microphone = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "microphone" },
            react_1.default.createElement("path", { id: "Icon", d: "M20 10C20 9.44772 19.5523 9 19 9C18.4477 9 18 9.44772 18 10H20ZM6 10C6 9.44772 5.55228 9 5 9C4.44772 9 4 9.44772 4 10H6ZM11 22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22H11ZM8 21C7.44772 21 7 21.4477 7 22C7 22.5523 7.44772 23 8 23V21ZM16 23C16.5523 23 17 22.5523 17 22C17 21.4477 16.5523 21 16 21V23ZM18 10V12H20V10H18ZM6 12V10H4V12H6ZM12 18C8.68629 18 6 15.3137 6 12H4C4 16.4183 7.58172 20 12 20V18ZM18 12C18 15.3137 15.3137 18 12 18V20C16.4183 20 20 16.4183 20 12H18ZM11 19V22H13V19H11ZM8 23H16V21H8V23ZM14 5V12H16V5H14ZM10 12V5H8V12H10ZM12 14C10.8954 14 10 13.1046 10 12H8C8 14.2091 9.79086 16 12 16V14ZM14 12C14 13.1046 13.1046 14 12 14V16C14.2091 16 16 14.2091 16 12H14ZM12 3C13.1046 3 14 3.89543 14 5H16C16 2.79086 14.2091 1 12 1V3ZM12 1C9.79086 1 8 2.79086 8 5H10C10 3.89543 10.8954 3 12 3V1Z" }))));
};
exports.default = Microphone;
